import { Navigate } from "react-router-dom";
import { useAppUrls } from "~/appUrls";

// we need this to ensure when we navigate home the org slug is set correctly via the appUrls
export function NavigateHome() {
  const urls = useAppUrls();
  return <Navigate to={urls.projectsRoute()} />;
}
